module.exports = __webpack_public_path__ + "img/splash_sceen_img_1.442897f2.png";